export const areaFormModel = {
  formId: 'areaForm',
  formField: {
    name: {
      name: 'name',
      label: 'Nombre del Área*',
      errorMsg: 'El nombre es requerido',
    },
    description: {
      name: 'description',
      label: 'Descripción (Opcional)',
    },
  },
};
